import { render } from "./QuizOnboarding.vue?vue&type=template&id=1aae4502&scoped=true"
import script from "./QuizOnboarding.vue?vue&type=script&lang=js"
export * from "./QuizOnboarding.vue?vue&type=script&lang=js"

import "./QuizOnboarding.vue?vue&type=style&index=0&id=1aae4502&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aae4502"]])

export default __exports__